import { Controller } from '@hotwired/stimulus';

import { JWPlayerAnalytics } from '../javascript/jwplayer-analytics';

function loadScript(source: string, async = true, type = 'text/javascript') {
  return new Promise((resolve, reject) => {
    try {
      const scriptElement = document.createElement('script');
      scriptElement.type = type;
      scriptElement.async = async;
      scriptElement.src = source;

      scriptElement.addEventListener('load', () => {
        resolve({ status: true });
      });

      scriptElement.addEventListener('error', () => {
        reject(new Error(`Failed to load the script ${source}`));
      });

      document.head.append(scriptElement);
    } catch (error: unknown) {
      reject(error instanceof Error ? error : new Error(String(error)));
    }
  });
}

export default class VideoController extends Controller {
  static targets = ['player', 'modal'];
  static values = {
    playlist: String,
  };

  declare playlistValue: string;
  declare readonly hasPlaylistValue: boolean;
  declare readonly hasPlayerTarget: boolean;
  declare readonly playerTarget: HTMLDivElement;
  declare readonly hasModalTarget: boolean;
  declare readonly modalTarget: HTMLDivElement;

  player?: jwplayer.JWPlayer;

  private analytics?: JWPlayerAnalytics;

  async connect() {
    await loadScript('https://content.jwplatform.com/libraries/ReOllMIn.js');

    if (!this.hasModalTarget) {
      this.setupPlayer();
    }
  }

  disconnect() {
    this.player?.remove();

    if (this.analytics) {
      this.analytics.destroy();
      this.analytics = undefined;
    }
  }

  modelWillShow() {
    this.setupPlayer();
  }

  modelWillHide() {
    this.player?.remove();
  }

  setupPlayer() {
    this.player = jwplayer(this.playerTarget).setup({
      width: '100%',
      aspectratio: '16:9',
      playlist: this.playlistValue,
    });

    // Initialize analytics tracking for this player
    this.analytics = new JWPlayerAnalytics(this.player);
  }
}
